<template lang="pug">
        v-btn.menu-button.mr-4(
            :color="activeTransaction.color"
            :key="activeTransaction.id"
            dark
            depressed
            large
            @click="_setShowMenu(!showMenu)"
            ref="activator"
        )
            v-layout(column style="margin-top: -3px;")
                v-flex.xs12(style="display: flex; justify-content: center; align-items: center;")
                    v-icon(left) {{activeTransaction.icon}}
                    span.subheading.font-weight-bold.pt-1 {{activeTransaction.displayName}}
                v-flex.xs12
                    span.caption (F3) CAMBIAR
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { debounce } from 'lodash'
import KeyBinds from '@/mixins/KeyBinds'
export default {
    name: 'dte-selector-button',
    props: {},
    data: function() {
        return {
            bindings: {
                f3: () => {
                    if (this.activeSearchModals) return
                    if (!this.$refs || !this.$refs.activator) return
                    this.$refs.activator.$el.click()
                },
            },
        }
    },
    computed: {
        ...mapGetters('TransactionModule', {
            activeTransaction: 'activeTransaction',
            activeSearchModals: 'activeSearchModals',
        }),
        ...mapState('TransactionModule', {
            showMenu: 'showMenu',
        }),
    },
    methods: {
        _setShowMenu: debounce(function(bool) {
            this.setShowMenu(bool), 200
        }),
        ...mapActions('TransactionModule', {
            setTransactionType: 'setTransactionType',
            setShowMenu: 'setShowMenu',
        }),
    },
    watch: {},
    components: {},
    mixins: [KeyBinds],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss" scoped>
.menu-button {
    width: 220px;
}
</style>

